import React, {useState} from "react";
import {Input} from 'antd';


const {Search} = Input
const SearchBar = ({refference, keywordHandler, top, width}) => {
    const [value, setValue] = useState('');
    const handleKeyword = (e) => {
        keywordHandler(value)
        setValue(e.target.value)
    }

    return (
        <div ref={refference} style={{marginTop: top, width: width}}>
            <Search
                value={value}
                placeholder="Search"
                onPressEnter={handleKeyword}
                onSearch={(value) => {
                    handleKeyword(value)
                }}
                onChange={e => setValue(e.target.value)}
                style={{width: '100%', marginBottom: '18px'}}
            />
        </div>
    );
};

export default SearchBar;
